import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SharedServices } from '../../shared.service';
import { MatDialog } from '@angular/material/dialog';
import { EstadoAutorizacion } from 'src/app/patients/components/authorization-query/authorization-query.component';
import { NotificationDialogComponent, NotificacionData } from 'src/app/patients/notification-dialog/notification-dialog.component';
import { CommunicationService } from 'src/app/services/communication.service';

@Component({
  selector: 'app-header-movile',
  templateUrl: './header-movile.component.html',
  styleUrls: ['./header-movile.component.scss']
})
export class HeaderMovileComponent implements OnInit {
  userName: string = '';
  estados: EstadoAutorizacion[] = [];
  notificacionesActivas: number = 0;
  notificaciones: NotificacionData[] = [];
  isLoading = false;
  showComponents = false;
  ipsData: any[] = [];
  private ipsIntervalId: any;
  constructor(
    private dialog: MatDialog,
    private sharedService: SharedServices,
    private router: Router,
    private comm: CommunicationService
  ) {
    this.userName = this.sharedService.userLogin.name;
  }
  @ViewChild('dialogCerrarSesion') dialogCerrarSesionTpl!: TemplateRef<any>;
  ngOnInit(): void {
    this.isLoading = true;

    const data = {
      action: 'CONTADOR_ESTADOS',
      numberId: this.sharedService.userLogin.numberId,
      tipoServicio: 'NOPBS'
    };
    this.comm.event$.subscribe(() => {

      this.sharedService.postPortalPaciente(data).subscribe((res: EstadoAutorizacion[]) => {
        this.estados = res
          .filter(e => e.name)
          .sort((a, b) => {
            if (a.id === 11) return 1;
            if (b.id === 11) return -1;
            return 0;
          });

        console.log('📊 Estados cargados:', this.estados);
        // Calcula las notificaciones, pero NO abre el diálogo automáticamente
        this.calcularNotificaciones(this.estados);
        this.isLoading = false;
      });

    });
    this.cargarIps();
    this.ipsIntervalId = setInterval(() => {
      this.cargarIps();
    }, 150000);
    this.sharedService.postPortalPaciente(data).subscribe((res: EstadoAutorizacion[]) => {
      this.estados = res
        .filter(e => e.name)
        .sort((a, b) => {
          if (a.id === 11) return 1;
          if (b.id === 11) return -1;
          return 0;
        });

      console.log('📊 Estados cargados:', this.estados);

      // Calcula las notificaciones, pero NO abre el diálogo automáticamente
      this.calcularNotificaciones(this.estados);
      this.isLoading = false;
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log('🔄 Cambio de ruta detectado, recalculando notificaciones...');
        this.cargarEstadosYNotificaciones();
      }
    });

  }
  ngOnDestroy(): void {
    if (this.ipsIntervalId) {
      clearInterval(this.ipsIntervalId);
    }
  }

  private cargarIps() {
    console.log('🚀 Ejecutando búsqueda de IPS');

    this.sharedService.postRegisterUser({
      action: 'SERCH_PACIENTE_IPS',
      numberId: this.sharedService.userLogin.numberId
    }).subscribe({
      next: res => {
        console.log('✅ IPS response:', res);
        this.ipsData = res;
      },
      error: err => console.error('❌ IPS error:', err),
      complete: () => console.log('🏁 IPS request completed')
    });
  }

  /**
   * Calcula las notificaciones activas según los estados (usando tus campos reales)
   */
  calcularNotificaciones(estados: EstadoAutorizacion[]) {
    this.notificaciones = [];

    const estado2 = estados.find(e => e.id === 2 && e.estado === 1);
    const estado5 = estados.find(e => e.id === 5 && e.estado > 0);

    if (estado2) {
      this.notificaciones.push({
        tipo: 'estado2',
        mensaje:
          'Solo queda una entrega pendiente de tu tratamiento. Si necesitas continuar, te recomendamos hacer la solicitud directamente con tu EPS.'
      });
    }

    if (estado5) {
      this.notificaciones.push({
        tipo: 'estado5',
        mensaje:
          'Debes validar tu información para continuar con la entrega de tus medicamentos.',
        boton: {
          texto: 'Ir a Mi Perfil',
          accion: () => this.irAMiPerfil()
        }
      });
    }

    // 🔥 UNA NOTIFICACIÓN POR CADA IPS
    this.ipsData.forEach((ips, index) => {
      this.notificaciones.push({
        tipo: 'notifIps',
        mensaje: `
        Para la aplicación de su
medicamento, debe
dirigirse a la IPS
asignada:
        ${ips.razonSocial} - ${ips.autorizacion}
      `,
        boton: {
          texto: 'Ver detalles',
          accion: () => this.verDetalleIps(ips)
        }
      });
    });

    this.notificacionesActivas = this.notificaciones.length;
  }
  verDetalleIps(ips: any) {
    this.dialog.open(NotificationDialogComponent, {
      width: '420px',
      panelClass: 'custom-dialog-container',
      data: {
        notificaciones: [
          {
            tipo: 'ipsDetalle',
            mensaje: `
            IPS: ${ips.razonSocial}
            Sucursal: ${ips.nombreSucursal}
            Dirección: ${ips.direccionIPS}
            Barrio: ${ips.barrio}
            Municipio: ${ips.munucipio}
            Teléfono: ${ips.telefono}
            Contacto: ${ips.personaContacto}
            Autorización: ${ips.autorizacion}
          `
          }
        ]
      }
    });
  }

  private cargarEstadosYNotificaciones() {
    const data = {
      action: 'CONTADOR_ESTADOS',
      numberId: this.sharedService.userLogin.numberId,
      tipoServicio: 'NOPBS'
    };

    this.sharedService.postPortalPaciente(data).subscribe((res: EstadoAutorizacion[]) => {
      this.estados = res
        .filter(e => e.name)
        .sort((a, b) => {
          if (a.id === 11) return 1;
          if (b.id === 11) return -1;
          return 0;
        });

      console.log('📊 Estados cargados:', this.estados);

      this.calcularNotificaciones(this.estados);
      this.isLoading = false;
    });
  }

  /**
   * Abre el diálogo al hacer clic en la campana solo si hay notificaciones activas
   */
  abrirDialogoNotificaciones() {
    if (this.notificacionesActivas === 0) return;

    this.dialog.open(NotificationDialogComponent, {
      width: '420px',
      panelClass: 'custom-dialog-container',
      data: { notificaciones: this.notificaciones }
    });
  }

  irAMiPerfil() {
    // console.log('aaaaa')
    this.router.navigateByUrl('/patients/personal-information');
  }
  goInit() {
    this.router.navigateByUrl('/patients');

  }
  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }
  /** 🔒 Diálogo de cerrar sesión */
  abrirDialogoCerrarSesion() {
    this.dialog.open(this.dialogCerrarSesionTpl, {
      width: '380px',
      panelClass: 'custom-dialog-container'
    });
  }

  cerrarDialogo() {
    this.dialog.closeAll();
  }

  confirmarCerrarSesion() {
    this.dialog.closeAll();
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }
}